const color = {
  lightGray: '#b5b5b5',
  white: '#ffffff',
  red: '#ff0000',
  black: '#000000'
}

export default color